exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-slick-border-hover[data-v-78a8eb49]{border:none}.custom-slick-border-hover[data-v-78a8eb49]:hover{border:solid;border-width:1px!important}", ""]);

// exports
